document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".tab");

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      // Remove active class from all tabs and content
      tabs.forEach((t) => t.classList.remove("active"));

      // Add active class to the clicked tab and corresponding content
      tab.classList.add("active");
      const targetId = tab.getAttribute("data-target");
      if (widgetFunctions[targetId]) {
        widgetFunctions[targetId]();
      }
      if (ratingsFunctions[targetId]) {
        ratingsFunctions[targetId]();
      }
    });
  });
});
